import { createSlice } from '@reduxjs/toolkit';

export const errorsSlice = createSlice({
  name: 'errors',
  initialState: {
    error: false,
  },
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload;
    },
  },
});
